import React from "react"
import Drawer from "@mui/material/Drawer"
import List from "@mui/material/List"
import ListItem from "@mui/material/ListItem"
import ListItemButton from "@mui/material/ListItemButton"
import ListItemText from "@mui/material/ListItemText"
import { MenuOption } from "../../utils/types"
import { Link } from "react-router-dom"
import "./MenuDrawer.scss"
import classNames from "classnames"
import CloseIcon from "../../assets/images/close-burger-menu-icon.svg?react"
import mainLogo from "../../assets/images/main-logo.svg"

interface DrawerProps {
  isOpen: boolean
  onRequestClose: () => void
  menuOptions: MenuOption[]
}

export const MenuDrawer: React.FC<DrawerProps> = ({
  isOpen,
  onRequestClose,
  menuOptions,
}) => {
  const list = () => (
    <List>
      {menuOptions.map((option) => (
        <ListItem key={option.id}>
          {option.isExternal ? (
            <ExternalLinkButton
              link={option.linksTo}
              onRequestClose={onRequestClose}
              displayText={option.displayText}
              isActive={option.isActive}
            />
          ) : (
            <InternalNavigationButton
              link={option.linksTo}
              onRequestClose={onRequestClose}
              displayText={option.displayText}
              isActive={option.isActive}
            />
          )}
        </ListItem>
      ))}
    </List>
  )

  return (
    <Drawer
      anchor="top"
      open={isOpen}
      onClose={onRequestClose}
      className="menu-drawer"
    >
      <div className="menu-drawer-outer-box">
        <div className="menu-drawer-header">
          <DrawerCloseButton onButtonClick={onRequestClose} />
          <img src={mainLogo} alt="main logo for header" />
        </div>
        {list()}
      </div>
    </Drawer>
  )
}

const ExternalLinkButton: React.FC<{
  link: string
  onRequestClose: () => void
  displayText: string
  isActive?: boolean
}> = ({ link, onRequestClose, displayText, isActive = false }) => (
  <a href={link} target="_blank" rel="noopener noreferrer">
    <ListItemButton
      className={classNames("menu-drawer-button", { active: isActive })}
      onClick={onRequestClose}
    >
      <ListItemText primary={displayText} />
    </ListItemButton>
  </a>
)

const InternalNavigationButton: React.FC<{
  link: string
  onRequestClose: () => void
  displayText: string
  isActive?: boolean
}> = ({ link, onRequestClose, displayText, isActive = false }) => {
  if (!displayText || !link) {
    return null
  }
  return (
    <Link to={link}>
      <ListItemButton
        className={classNames("menu-drawer-button", { active: isActive })}
        onClick={onRequestClose}
      >
        <ListItemText primary={displayText.toUpperCase()} />
      </ListItemButton>
    </Link>
  )
}

const DrawerCloseButton: React.FC<{
  onButtonClick: () => void
}> = ({ onButtonClick }) => {
  return (
    <button onClick={onButtonClick} className="menu-drawer-close-button">
      <CloseIcon width={20} height={20} />
    </button>
  )
}
